var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMailSend = function SvgMailSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mail-send_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M22.092.795a2 2 0 0 0-.288.076c-.393.14-20.294 7.802-20.43 7.865-.17.079-.362.248-.446.393a.93.93 0 0 0-.132.564c.02.399.225.69.62.882.112.054 2.008.917 4.212 1.917s4.02 1.831 4.034 1.846c.015.014.845 1.83 1.846 4.034 1 2.204 1.863 4.1 1.918 4.21.126.26.29.432.51.537.154.072.18.077.428.077.251 0 .272-.004.422-.08q.315-.156.466-.47c.078-.16 7.736-20.045 7.889-20.486a.86.86 0 0 0 .062-.42.8.8 0 0 0-.085-.379 1.01 1.01 0 0 0-1.026-.566m-9.654 5.824A1323 1323 0 0 0 4.416 9.72c0 .009 1.302.607 2.894 1.33l2.894 1.316 2.176-2.171c2.033-2.029 2.186-2.176 2.326-2.237.408-.178.847-.105 1.143.192.297.296.37.735.192 1.143-.061.14-.208.293-2.237 2.326l-2.171 2.177 1.315 2.893a186 186 0 0 0 1.33 2.894c.01 0 1.392-3.577 3.073-7.95 1.682-4.372 3.072-7.985 3.09-8.028a.3.3 0 0 0 .025-.076c-.003 0-3.616 1.39-8.028 3.089",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "mail-send_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgMailSend;